<template>
  <div class="page-content">
    <div class="page-header">
      <div>
        <BreadcrumbComponent :items="items" />
        <h1 class="page-title">Taux du Jour</h1>
        <p class="page-subtitle">Configurez le taux de conversion pour chaque emplacement</p>
      </div>
    </div>

    <PreloaderComponent :enable="enable" />

    <div v-if="enable">
      <v-row>
        <v-col cols="12" md="5" v-for="rate in activeRates" :key="rate.id">
          <v-card flat class="rate-card">
            <div class="rate-card-header">
              <v-icon color="white" size="20">mdi-store</v-icon>
              <span>{{ rate.store.name }}</span>
            </div>
            <v-card-text class="pa-6">
              <div class="rate-display">
                <div class="rate-from">
                  <div class="rate-flag">USD</div>
                  <span class="rate-amount">1.00</span>
                </div>
                <v-icon color="primary" size="24" class="mx-3">mdi-arrow-right</v-icon>
                <div class="rate-to">
                  <div class="rate-flag rate-flag--htg">HTG</div>
                  <input
                    type="number"
                    v-model="rate.sales_rate"
                    @change="update(rate)"
                    @focus="focusedRate = rate.id"
                    @blur="onBlur(rate)"
                    step="0.01"
                    class="rate-input"
                    :class="{ 'rate-input--focused': focusedRate === rate.id }"
                  />
                </div>
              </div>
              <div class="rate-saved" v-if="savedRate === rate.id">
                <v-icon x-small color="success" class="mr-1">mdi-check-circle</v-icon>
                <span class="success--text text-caption">Enregistré</span>
              </div>
              <div class="rate-hint" v-else>
                <span class="text-caption text--secondary">Modifiez le montant et cliquez ailleurs pour sauvegarder</span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-alert v-if="activeRates.length === 0" type="info" text dense class="mt-4">
        Aucun taux configuré. Contactez le support.
      </v-alert>
    </div>
  </div>
</template>

<script>
import BreadcrumbComponent from '../components/BreadcrumbComponent.vue'
import PreloaderComponent from '../components/PreloaderComponent.vue'
import { readUsdContext, persistUsdContext } from '../utils/usdPersistence'

export default {
  name: 'RatesView',
  components: { BreadcrumbComponent, PreloaderComponent },
  data: () => ({
    items: [{ text: 'Taux du Jour', disabled: true, href: '/rates' }],
    enable: false,
    rows: [],
    focusedRate: null,
    savedRate: null,
  }),
  computed: {
    activeRates() { return this.rows.filter(function (i) { return i.rate_id == 2 }) }
  },
  methods: {
    load() {
      var self = this
      this.$axios.get('/store-rates?include=store')
        .then(function (r) { self.rows = r.data; self.enable = true })
    },
    update(rate) {
      var self = this
      this.$axios.put('/store-rates/' + rate.id + '?data=' + encodeURIComponent(JSON.stringify(rate)))
        .then(function () {
          self.savedRate = rate.id
          setTimeout(function () { if (self.savedRate === rate.id) self.savedRate = null }, 2000)
          if (Number(rate.rate_id) === 2 && readUsdContext().hasUsd) {
            persistUsdContext(true, rate.sales_rate)
          }
        })
    },
    onBlur(rate) {
      this.focusedRate = null
      this.update(rate)
    },
  },
  mounted() { this.load() },
}
</script>

<style scoped>
.rate-card {
  border: 1px solid #e8ecf1 !important;
  border-radius: 12px !important;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04) !important;
  overflow: hidden;
}

.rate-card-header {
  background: #194173;
  color: white;
  padding: 12px 20px;
  font-size: 0.875rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

.rate-display {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 0 12px;
}

.rate-from, .rate-to {
  display: flex;
  align-items: center;
  gap: 10px;
}

.rate-flag {
  background: #194173;
  color: white;
  font-size: 0.6875rem;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 4px;
  letter-spacing: 0.05em;
}

.rate-flag--htg {
  background: #f68d3b;
}

.rate-amount {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1a2332;
}

.rate-input {
  width: 140px;
  padding: 8px 12px;
  font-size: 1.5rem;
  font-weight: 700;
  color: #f68d3b;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  outline: none;
  text-align: center;
  background: #fafbfc;
  transition: all 0.2s;
}

.rate-input--focused, .rate-input:focus {
  border-color: #f68d3b;
  box-shadow: 0 0 0 3px rgba(246, 141, 59, 0.15);
  background: #fff;
}

.rate-input::-webkit-inner-spin-button,
.rate-input::-webkit-outer-spin-button { -webkit-appearance: none; margin: 0; }
.rate-input { -moz-appearance: textfield; }

.rate-saved, .rate-hint {
  text-align: center;
  min-height: 20px;
  padding-top: 4px;
}
</style>
